"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20ApprovalDocumentBuilder = void 0;
var LogRelatedId_1 = require("../common/LogRelatedId");
var Erc20ApprovalDocumentBuilder = /** @class */ (function () {
    function Erc20ApprovalDocumentBuilder() {
    }
    Erc20ApprovalDocumentBuilder.build = function (approval, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: LogRelatedId_1.LogRelatedId.create(chain, approval.transactionHash, approval.logIndex),
            transactionHash: approval.transactionHash,
            contract: approval.contract,
            logIndex: approval.logIndex,
            owner: approval.owner,
            spender: approval.spender,
            value: approval.value,
            tokenDecimals: parseInt(approval.tokenDecimals, 10),
            tokenName: approval.tokenName,
            tokenSymbol: approval.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
        };
        return document;
    };
    return Erc20ApprovalDocumentBuilder;
}());
exports.Erc20ApprovalDocumentBuilder = Erc20ApprovalDocumentBuilder;
//# sourceMappingURL=Erc20ApprovalDocumentBuilder.js.map